import React, { useEffect, useState } from 'react';

import { Button, Toast } from 'antd-mobile';
import * as crypto from 'crypto-js';
import { ApiCore } from '../../api';
import { createFromIconfontCN } from '@ant-design/icons';
import styles from './findList.module.scss';

const api = new ApiCore();

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2323742_xvjwsudf76n.js',
});

function FindList(props: any) {

    const [findLists, setFindLists] = useState<any>(null);

    useEffect(() => {
        //设置网页title
        document.title = '发现';
        getFindLists(props.userId)
    }, [])

    // 发现列表
    const getFindLists = (userId: any) => {
        let params = {
            userId
        }
        api.GetConfigFind(params).then(res => {
            if (res.code == '0') {
                setFindLists(res.data)
            }
        })
    }


    // 立即进入/查看详情
    const onDetails = (item: any) => {

        // 立即进入-已绑定对应平台账号的CRC，跳转到对应小程序
        if (item.btnType == 'APP') {

            let localStorage_accountInf = localStorage.getItem('accountInf');
            if (localStorage_accountInf) {
                let accountInf = JSON.parse(localStorage_accountInf);

                let params = {
                    appCode: item.appCode,
                    userId: accountInf.account
                }
                api.GetConfigDetail(params).then(res => {
                    if (res.code == '0') {
                        if (res.data.step1Type == 'APP') {
                            // window.location.href = res.data.step1Url
                            
                            if (!res.data.uid || res.data.uid == '' || res.data.uid == null) {
                                Toast.fail('绑定失败，未获得联合ID')
                                return
                            }
                            window['wx'].miniProgram.navigateTo({
                                url: `/pages/loading/loading?uid=${res.data.uid}`,
                                success: function(e: any){
                                    console.log('e:',e)
                                },
                                fail: function(e: any) {
                                    console.log('e:',e)
                                }
                            })
                        }
                    }
                })
            }
        }
        // 查看详情-未绑定对应平台账号的CRC，进入对应小程序的详情介绍页-
        else if (item.btnType == 'H5') {
            sessionStorage.setItem('appCode', item.appCode)
            props.history.push(`/findList/details/details`)
        }
        // 暂未上线
        else if (item.btnType == 'NotStart') {

        }
    }

    return (
        <div className={styles.findContent}>

            {findLists && findLists.length > 1 && findLists.map((item: any, index: any) => (
                <div key={index}
                    className={styles.listItem}
                >
                    <img
                        src={item.backgroundUrl} alt='' className={styles.Img}
                        style={{ transform: index % 2 == 0 ? `scaleX(1)` : `scaleX(-1)` }}
                    />
                    <div style={{ alignItems: index % 2 == 0 ? `flex-start` : `flex-end`, textAlign: index % 2 == 0 ? 'left' : 'right' }} className={styles.container}>
                        <div className={styles.tit} style={{ textAlign: index % 2 == 0 ? 'left' : 'right' }}>{item.title}</div>
                        <div className={styles.con} >{item.describe}</div>
                        <Button
                            className={styles.btn}
                            size="small"
                            disabled={item.btnType == 'NotStart'}
                            onClick={() => onDetails(item)}
                            style={{ background: `${item.color}` }}
                        >
                            {item.btnText}
                        </Button>
                    </div>
                </div>
            ))}

            {/* 只有一个导流模块 */}
            {findLists && findLists.length == 1 && findLists.map((item: any, index: any) => (
                <div key={index} className={styles.listItemOne}>
                    <img
                        src={item.bigPictureUrl} alt=''
                        className={styles.Img}
                    />
                    <div className={styles.container}>
                        {/* <div className={styles.tit} style={{ textAlign: index % 2 == 0 ? 'left' : 'right' }}>{item.title}</div> */}
                        <div className={styles.con}>{item.describe}</div>
                        <Button
                            className={styles.btn}
                            size="small"
                            disabled={item.btnType == 'NotStart'}
                            onClick={() => onDetails(item)}
                            style={{ background: `${item.color}` }}
                        >
                            {item.btnText}
                        </Button>
                    </div>
                </div>
            ))}


        </div>
    )
}

export default FindList;